import "./Right_nav.css";

export default function Right_nav({ setActivePage }) {
  const navigation = [
    { name: "ALGO_DEFINATION", key: "home" },
    { name: "TEAM RESULTS", key: "team_results" },
    { name: "ALGORITHM 1", key: "algorithm_1" },
    { name: "ALGORITHM 2", key: "algorithm_2" },
  ];

  return (
    <nav className="right_nav">
      <div className="right_nav_header">
        <span className="right_nav_title">NAVIGATION</span>
      </div>

      <div className="right_nav_list">
        {navigation.map((item, index) => (
          <button
            key={item.key}
            type="button"
            className="right_nav_item"
            onClick={() => setActivePage(item.key)}
          >
            <span className="right_nav_number">
              {String(index + 1).padStart(2, "0")}
            </span>

            <span className="right_nav_name">{item.name}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
